import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'
const ECG_PATH = 'ecg'
export function getUserECGData(userId, brand) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${ECG_PATH}/getUserECG`, {
            params: {
                userId,
                brand,
            },
        })
        .then(res => {
            return res.data ? res.data : null
        })
        .catch(error => console.log(error))
}

export function createOrUpdateECG(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${ECG_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageElectrocardiograms(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${ECG_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
